export enum UnitSystem {
    IMPERIAL = 1,
    METRIC = 2,
}

export enum UnitSystemStr {
    IMPERIAL = 'imperial',
    METRIC = 'metric',
}

export function getUnitSystemStr(value: UnitSystem): UnitSystemStr {
    return {
        [UnitSystem.IMPERIAL]: UnitSystemStr.IMPERIAL,
        [UnitSystem.METRIC]: UnitSystemStr.METRIC,
    }[value];
}

export function getUnitSystem(value: UnitSystemStr): UnitSystem {
    return {
        [UnitSystemStr.IMPERIAL]: UnitSystem.IMPERIAL,
        [UnitSystemStr.METRIC]: UnitSystem.METRIC,
    }[value];
}
